var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoAuthorizationSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29,7.2421875V8h-0.7578125l-2,2H29v2h-4.7578125l-2,2H29v11c0,0.5517578-0.4482422,1-1,1H10.2421875l-2,2H28 c1.6542969,0,3-1.3457031,3-3V7c0-0.506958-0.1381836-0.9776001-0.361084-1.3967285L29,7.2421875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,24.7578125V14h10.7578125l2-2H3v-2h14.7578125l2-2H3V7c0-0.5517578,0.4482422-1,1-1h17.7578125l2-2H4 C2.3457031,4,1,5.3457031,1,7v18c0,0.506958,0.1382446,0.9775391,0.361145,1.3966675L3,24.7578125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,18v3.7578125l2-2V19h0.7578125l2-2H7C6.4472656,17,6,17.4472656,6,18z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26,17 19.2421875,17 17.2421875,19 26,19  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 21,
    width: 5,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5.2132034,
    y: 15.0001068,
    transform: "matrix(0.7071068 -0.7071068 0.7071068 0.7071068 -6.6274171 16)",
    width: 42.4264069,
    height: 1.9997864
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAuthorizationSmall);
export default __webpack_public_path__ + "static/media/no-authorization--small.802a945126b795b0bcfdb37c20041458.svg";
export { ForwardRef as ReactComponent };